export enum SmsButtonState {
  CLOSED,
  OPEN,
  SENDING,
  PARTIAL_SUCCESS,
  ERROR,
}

export type TSendSmsFormValues = {
  phone: string;
  sender: string;
  message: string;
};

export type TSendSmsButtonState = {
  open: boolean;
  state: SmsButtonState;
  errors: TSendSmsApiResponseError[];
  initialValues: TSendSmsFormValues;
};

export type TSendSmsApiResponseStatus = "ERROR" | "PARTIAL_SUCCESS" | "SUCCESS";

export type TSendSmsApiResponseErrorCode = "unknown" | "sms_denied_before";

export type TSendSmsApiResponseError = {
  phone: string;
  error_code: TSendSmsApiResponseErrorCode;
  error_detail: string;
};

export type TSendSmsApiResponse = {
  status: TSendSmsApiResponseStatus;
  sms_sent: number;
  errors: TSendSmsApiResponseError[];
};
